
export const SLIDE_WIDTH: number = 1024
export const SLIDE_HEIGHT: number = 576
